import React from 'react';
import PropTypes from 'prop-types';

import RadioGroup from '@decisiv/ui-components/lib/components/RadioGroup';

import { PERMISSIONS_SECTION } from './copy';
import { ScopeRow } from './styles';

/**
 * "Apply to All Accounts" / "Custom per Account", rendered only for more than
 * one account. Plain KeyDS RadioGroup, not the wizard's WizardRadioGroup —
 * that workaround is for controlled inputs inside a portal.
 */
function ScopeChoice({ disabled, mode, onChange }) {
  return (
    <ScopeRow>
      <RadioGroup
        disabled={disabled}
        items={[
          { label: PERMISSIONS_SECTION.applyToAll, value: 'all' },
          { label: PERMISSIONS_SECTION.customPerAccount, value: 'custom' },
        ]}
        name="permissions-scope"
        onChange={(event) => onChange(event.target.value)}
        value={mode}
      />
    </ScopeRow>
  );
}

ScopeChoice.propTypes = {
  disabled: PropTypes.bool,
  mode: PropTypes.oneOf(['all', 'custom']).isRequired,
  onChange: PropTypes.func.isRequired,
};

ScopeChoice.defaultProps = {
  disabled: false,
};

export default ScopeChoice;
